<template>
  <div class="linkFormSectionWrap">
    <link-form-tag-card
      :tag-v-o-list.sync="ruleForm.tagVOList"
      :tags-required="tagsRequired"
      :show-completion-status="showCompletionStatus"
      :completion-done="completionDone"
    />
  </div>
</template>

<script>
import LinkFormTagCard from '../../../views/resourceManage/genericResourceManage/association/LinkFormTagCard.vue'

/**
 * 通用资源创建/编辑 · 关联 Tag 区块。
 * workout_action 下 Tag 必填（至少 1 个），由 FormShell 注入 tagsRequired / 完成度角标。
 */
export default {
  name: 'GenericResourceTagSection',
  components: { LinkFormTagCard },
  props: {
    ruleForm: { type: Object, required: true },
    tagsRequired: { type: Boolean, default: false },
    showCompletionStatus: { type: Boolean, default: false },
    completionDone: { type: Boolean, default: false },
  },
  methods: {
    validate() {
      if (!this.tagsRequired) {
        return Promise.resolve()
      }
      const tags = Array.isArray(this.ruleForm.tagVOList) ? this.ruleForm.tagVOList : []
      if (tags.length > 0) {
        return Promise.resolve()
      }
      return Promise.reject('请至少关联一个 Tag')
    },
    captureSnapshot() {
      return JSON.parse(JSON.stringify(this.ruleForm.tagVOList || []))
    },
  },
}
</script>
